import { HttpResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { isArray } from 'lodash';
import moment from 'moment';
import { ToastrService } from 'ngx-toastr';
import { CommonService } from 'src/app/services/common.service';
import { DashboardService } from '../../dashboard/dashboard.service';
import { NursingService } from '../nursing.service';
import * as global from '../../global';
import { API_URL } from "../../../../environments/api-url";
import { MatDialog } from '@angular/material/dialog';
import { ExportNotesDialogComponent } from 'src/app/shared/popup-dialogs/export-notes-dialog/export-notes-dialog.component';
import { NoteEditorService } from '../../note-editor/note-editor.service';
import { ActivatedRoute, Router } from '@angular/router';
import { CompanyService } from 'src/app/services/Modules/company.service';
import { AuthService } from 'src/app/services/auth.service';


@Component({
  selector: 'app-nursing-dashboard',
  templateUrl: './nursing-dashboard.component.html',
  styleUrls: ['./nursing-dashboard.component.css']
})
export class  NursingDashboardComponent implements OnInit {
  leftColClose: boolean;
  leftColWidth: boolean;
  selectedProvider: any;
  selectedfacility: any;
  facilityControl = new FormControl();
  providerControl = new FormControl();
  assoc_providersList: any;
  assoc_Facilities: any;
  transGroup = {
    group: 'Group by Date of Service',
    value: 'date_of_service'
  };
  transGrouping = [
    {
      group: 'Group by Date of Service',
      value: 'date_of_service'
    },
    {
      group: 'Group by Date of Creation',
      value: 'creation_date'
    }
  ];
  transcriptionsGroupingKey: string = 'date_of_service';
  preDateRanges: any = {
    'Today': [moment(), moment()],
    'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
    'Last 7 Days': [moment().subtract(6, 'days'), moment()],
    'Last 30 Days': [moment().subtract(29, 'days'), moment()],
    'This Month': [moment().startOf('month'), moment().endOf('month')],
    'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
  };
  noteDateFilter = {
    startDate: moment().subtract(7, 'days'),
    endDate: moment()
  };
  searchTextProvider: any;
  searchText:any;
  groupedSortedTranscriptions: {};
  sortedTransriptions: any;
  multiSelectedTranscriptions: Array<any> = [];
  public element: string;
  newTitleElem: any;
  headingTags: any;
  title: any;
  titleContainer: any;
  dashboardView:boolean=true;
  reportView: any;
  currentUser: any;
  reportsNames: any=[];

  constructor(
    private _service: NursingService,
    public _commonService: CommonService,
    private toastr: ToastrService,
    private dashboard: DashboardService,
    private dialog: MatDialog,
    private noteEditorService: NoteEditorService,
    private companyService: CompanyService,
    private _authService: AuthService,

  ) { 
    this.currentUser = this._authService.currentUser;
    this.getSettings();
  }

  ngOnInit(): void {
    this.reportView='';
    this.initFacilities();
  }
  closeLeftCol() {
    this.leftColClose = true;
    this.leftColWidth = true;
  }

  openLeftCol() {
    this.leftColWidth = false;
    setTimeout(() => {
      this.leftColClose = false;
    }, 250);
  }
  refreshDashboard() {
    this.dashboardView=true;
  }
  openReport(route){
    this.dashboardView=false;
      this.reportView=route||'';
    console.log("reportView : ", this.reportView);
  }

  getSettings(){
    this.companyService.getCompanyReportSettings(this.currentUser.company_id).subscribe((response: any) => {
        if(response.data?.length){
          this.reportsNames=[];
          response.data.forEach(element => {
              if(element.selected&&(element.user_type.findIndex(e=>e=='nurse')>=0)){
                this.reportsNames.push(element);
              }
          });
        }
    })
  }

  async initFacilities() {
    await this._service.getAssociatedFacilities().subscribe((res: any) => {
      if (res.status == 200) {
        this.assoc_Facilities = res.data.array;
        this.selectedfacility = this.assoc_Facilities[0];
        this.getProvidersByFacility(0);
      }
    });
  }
  getProvidersByFacility(index) {
    this.assoc_providersList = this.assoc_Facilities[index].provider_ids_ref;
    this.assoc_providersList.sort((a, b) => a.first_name.toLowerCase().localeCompare(b.first_name.toLowerCase()));
    this.selectedProvider = this.assoc_providersList[0];
    this.getAllProviderNotes();
  }
  async getAllProviderNotes() {
    let start = this.noteDateFilter.startDate;
    let end = this.noteDateFilter.endDate;
    console.log("selectedfacility : ", this.selectedfacility, this.selectedProvider);
   
    if(this.selectedfacility&&this.selectedProvider){
      await this._service.getAllProviderNotes(this.selectedfacility._id, this.selectedProvider._id, end, start).subscribe((res: any) => {
        if (res.status == 200) {
          this.sortedTransriptions = res.data.array;
          this.groupedSortedTranscriptions = this.groupItemListV1(this.sortedTransriptions,
            this.transcriptionsGroupingKey);
        }
      })
    }else{
        console.log("selectedfacility or selectedProvider, doewsn't exist: ", this.selectedfacility, this.selectedProvider);
    }
  }
  async exportNote(option: any) {
    if (option === 'download') {
      if (this.multiSelectedTranscriptions.length > 0) {
        this.toastr.info('Downloading Notes', 'Downloading...');
        this.multiSelectedTranscriptions = this.multiSelectedTranscriptions.map(d => d?._id)
      }
      const fileName = `${this.multiSelectedTranscriptions.length} note(s).pdf`;
      //const fileName = `${this.multiSelectedTranscriptions.length} note(s).zip`;

      
      await this.dashboard.downloadFile(global.url + API_URL.NOTE.encrypted_zip_file, this.multiSelectedTranscriptions).subscribe((res: any) => {
      //await this.dashboard.downloadFile(global.url + API_URL.NOTE.generateMultiplePDF, this.multiSelectedTranscriptions).subscribe((res: any) => {
        if (res instanceof HttpResponse) {

          var url = window.URL.createObjectURL(res.body);
          var a = document.createElement('a');
          document.body.appendChild(a);
          a.setAttribute('style', 'display: none');
          a.href = url;
          a.download = fileName;
          a.click();
          window.URL.revokeObjectURL(url);
          a.remove(); // remove the element
        this.toastr.info('File Downloaded successfully.', 'Success');

        } else {

        }
      }, (err) => {
        this.toastr.error('Something went wrong while downloading notes', 'Failed');
      },
        () => {
        });
      this.multiSelectedTranscriptions = []
      this.multiSelectedTranscriptions.length = 0;
    }
    else if (option === 'send_to_email') {
      const dialogRef = this.dialog.open(ExportNotesDialogComponent, { width: '40%' });
      dialogRef.afterClosed().subscribe(async result => {
        if (result.emails.length > 0) {
          this.toastr.info('Sending email', 'Sending...');
          if (this.multiSelectedTranscriptions.length > 0) {
            this.multiSelectedTranscriptions = this.multiSelectedTranscriptions.map(d => d?._id)
          }
          
          this.noteEditorService.generatePDFsLinksAndEmail(result.emails, this.multiSelectedTranscriptions, this.selectedProvider?.first_name, this.selectedfacility?.title)

          //this.noteEditorService.generateEncryptedPDFsAndEmail(result.emails, this.multiSelectedTranscriptions, this.selectedProvider?.first_name, this.selectedfacility?.title)
          //this.noteEditorService.generatePDFsAndEmail(result.emails, this.multiSelectedTranscriptions, this.selectedProvider?.first_name, this.selectedfacility?.title)
            .subscribe((response: any) => {
              if (response.status == 200) {
                this.toastr.info('Email sent');
              }
            }, () => {
            }, () => {
              this.multiSelectedTranscriptions = []
              this.multiSelectedTranscriptions.length = 0;
            })
        }
      })
    }
  }
  displayProviderFn(provider): string {
    return provider && provider.first_name ? provider.first_name + " " + provider.last_name + ", " + provider.title : '';
  }
  displayFacilityFn(facility): string {
    return facility?.title ? facility.title : '';
  }
  applyDateFilterTrans($event: any) {
    this.getAllProviderNotes();
  }
  groupTranscriptionsBy(group_index) {
    this.transcriptionsGroupingKey = group_index;
    this.groupedSortedTranscriptions = this.groupItemListV1(this.sortedTransriptions, group_index);
  }
  groupItemList(itemList, groupByIndex) {
    let timezone = "America/New_York"
    const grouped = {};
    console.log("groupByIndex : ", groupByIndex);
    // for (const i in itemList) {
    for (let row of itemList) {
      const item = { ...row };
      if (item.facility_id_ref && item.facility_id_ref.pcc_timeZone) {
        timezone = item.facility_id_ref.pcc_timeZone
      }
      else if (item.facility_id_ref && item.facility_id_ref.timeZone) {
        timezone = item.facility_id_ref.timeZone
      }

      let groupIndex = item[groupByIndex];
      if (groupByIndex.indexOf('date') >= 0) {
        if (groupByIndex == 'date_time') {
          groupIndex = moment(new Date(item.filterServiceDate).toLocaleString('en-US', { timeZone: timezone })).format('MMM DD, YYYY');
        }
        else if (groupByIndex == 'uploading_date') {
          groupIndex = moment(new Date(item.filterUploadingDate).toLocaleString('en-US', { timeZone: timezone })).format('MMM DD, YYYY');

        }
        else if (groupByIndex == 'creation_date') {
          groupIndex = moment(new Date(item.filterCreationDate).toLocaleString('en-US', { timeZone: timezone })).format('MMM DD, YYYY');
        }
        else if (groupByIndex == 'date_of_service') {
          groupIndex = moment(new Date(item.filterServiceDate).toLocaleString('en-US', { timeZone: timezone })).format('MMM DD, YYYY');
        }
      }

      // if invalid key make undefined
      if (!groupIndex || groupIndex == 'Invalid date') {
        groupIndex = 'undefined';
      }

      if (!isArray(grouped[groupIndex])) {
        grouped[groupIndex] = [];
      }
      grouped[groupIndex].push(item);
    }
    for (let key in grouped) {
      // if one non empty found
      if (grouped[key].find(e => !e.empty)) {
        grouped[key] = grouped[key].filter(e => !e.empty);
      }
    }
    return grouped;
  }

  groupItemListV1(itemList, groupByIndex) { 
    let timezone = "America/New_York"
    let months = ['Jan', 'Feb', 'March']
    // date.toLocaleString('en-US', {month: 'short'});
    const grouped = {};
    // for (const i in itemList) {
    for (let row of itemList) {
        const item = { ...row };

        if (item.facility_id_ref && item.facility_id_ref.pcc_timeZone) {
            timezone = item.facility_id_ref.pcc_timeZone
        }
        else if (item.facility_id_ref && item.facility_id_ref.timeZone) {
            timezone = item.facility_id_ref.timeZone
        }

        let groupIndex = item[groupByIndex];

        if (groupByIndex.indexOf('date') >= 0) {
            if (groupByIndex == 'date_time') {

                // if is date, format date and discard time
                // groupIndex = this.datepipe.transform(item[groupByIndex], global.date_format);
                //mohsin
                // groupIndex = moment(new Date(item.filterServiceDate)).format('MMM DD, YYYY');
                //ali
                // groupIndex = moment(new Date(item.filterServiceDate).toLocaleString('en-US', { timeZone: item.timezone })).format('MMM DD, YYYY');
                // groupIndex = moment(new Date(item.filterServiceDate)).format('MMM DD, YYYY');
                if(item.date_obj && item.date_obj.year){
                    let {year, month, day, hour, minute} = item.date_obj;
                    // if(month < 10){
                    //     month = '0' + month;
                    // }
                    // if(day < 10){
                    //     day = '0' + day;
                    // }
                    let date = new Date(`${month}\/${day}\/${year}`);
                    //month = date.toLocaleString('en-US', {month: 'short'});
                    groupIndex=moment(date).format('MMM DD, YYYY');
                    // groupIndex = `${month} ${day}, ${year}` ;
                }
                else{
                    groupIndex = moment(new Date(item.filterServiceDate).toLocaleString('en-US', { timeZone: timezone })).format('MMM DD, YYYY');

                }

            }
            else if (groupByIndex == 'uploading_date') {

                // if is date, format date and discard time
                // groupIndex = this.datepipe.transform(item[groupByIndex], global.date_format);
                //mohsin
                // groupIndex = moment(new Date(item.filterUploadingDate)).format('MMM DD, YYYY');
                //ali
                // groupIndex = moment(new Date(item.filterUploadingDate).toLocaleString('en-US', { timeZone: item.timezone })).format('MMM DD, YYYY');
                // groupIndex = moment(new Date(item.filterUploadingDate)).format('MMM DD, YYYY');
                groupIndex = moment(new Date(item.filterUploadingDate).toLocaleString('en-US', { timeZone: timezone })).format('MMM DD, YYYY');

            }
            else if (groupByIndex == 'creation_date') {

                // if is date, format date and discard time
                // groupIndex = this.datepipe.transform(item[groupByIndex], global.date_format);
                //mohsin
                // groupIndex = moment(new Date(item.filterCreationDate)).format('MMM DD, YYYY');
                //ali
                groupIndex = moment(new Date(item.filterCreationDate).toLocaleString('en-US', { timeZone: timezone })).format('MMM DD, YYYY');
                // groupIndex = moment(new Date(item.filterCreationDate)).format('MMM DD, YYYY');
            }
            else if (groupByIndex == 'date_of_service') {
                // if is date, format date and discard time
                // groupIndex = this.datepipe.transform(item[groupByIndex], global.date_format);
                //mohsin
                // groupIndex = moment(new Date(item.filterServiceDate)).format('MMM DD, YYYY');
                // ali
                if(item.date_obj && item.date_obj.year){
                    let {year, month, day, hour, minute} = item.date_obj;
                    // if(month < 10){
                    //     month = '0' + month;
                    // }
                    // if(day < 10){
                    //     day = '0' + day;
                    // }
                    let date = new Date(`${month}\/${day}\/${year}`);
                    //month = date.toLocaleString('en-US', {month: 'short'});
                    groupIndex=moment(date).format('MMM DD, YYYY');
                    // groupIndex = `${month} ${day}, ${year}` ;
                }
                else{
                    groupIndex = moment(new Date(item.filterServiceDate).toLocaleString('en-US', { timeZone: timezone })).format('MMM DD, YYYY');

                }

                // groupIndex = moment(new Date(item.filterServiceDate)).format('MMM DD, YYYY');
            }
        }else{
            
            if(groupByIndex.indexOf('facility') >= 0){
                groupIndex=item.facility_id_ref?.title;
            }
            else if(groupByIndex.indexOf('patient') >= 0){
                groupIndex=item.patient_id_ref?.last_name+', '+item.patient_id_ref?.first_name;
            }
            else  if(item.date_obj && item.date_obj.year){
                let {year, month, day, hour, minute} = item.date_obj;
                
                let date = new Date(`${month}\/${day}\/${year}`);
                groupIndex=moment(date).format('MMM DD, YYYY');
            }
            else{
                groupIndex = moment(new Date(groupIndex).toLocaleString('en-US', { timeZone: timezone })).format('MMM DD, YYYY');
                
            }

        }



        // if invalid key make undefined
        if (!groupIndex || groupIndex == 'Invalid date') {
            groupIndex = 'undefined';
        }

        if (!Array.isArray(grouped[groupIndex])) {
            grouped[groupIndex] = [];
        }
        grouped[groupIndex].push(item);
    }
    // remove empty items if atleast one non empty item in a group
    for (let key in grouped) {
        // if one non empty found
        if (grouped[key].find(e => !e.empty)) {
            grouped[key] = grouped[key].filter(e => !e.empty);
        }
    }
    return grouped;
}


  toggleTranscriptionMultiSelect(transcription: any) {
    const i = this.multiSelectedTranscriptions.indexOf(transcription);
    if (i === -1) {
      this.multiSelectedTranscriptions.push(transcription);
    } else {
      this.multiSelectedTranscriptions.splice(i, 1);
    }
  }
  isNotesLoading() {
  }
}
